import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import { ApiService } from "src/app/service/apiServices";
import Swal from "sweetalert2";

@Component({
  selector: "app-modal-anexo-documento-externo",
  templateUrl: "./modal-anexo-documento-externo.component.html",
  styleUrls: ["./modal-anexo-documento-externo.component.css"],
})
export class ModalAnexoDocumentoExternoComponent implements OnChanges {
  @Input() isVisible: boolean = false;
  @Input() atendimento: any;
  @Output() close = new EventEmitter<void>();
  arquivoSelecionado: File | null = null;
  permiteSalvar: boolean = false;
  permiteSalvarRegistro: boolean = false;
  tipoSelecionado: number = 0;
  nomeArquivoSalvo: string = "";
  tiposArquivoBloqueados: string[] = [
    "text/javascript",
    "",
    "application/x-msdownload",
    "text/xml",
    "text/html",
    "text/css",
    "application/json",
    "application/vnd.android.package-archive",
  ];

  tiposDocumento = [
    { label: "Receituário", value: 1 },
    { label: "Atestado", value: 2 },
    { label: "Declaração", value: 3 },
    { label: "Exame", value: 4 },
    { label: "Laudo", value: 10 },
  ];

  constructor(
    public service: ApiService
    
  ) {}
  ngOnChanges() {}

  fecharModal = () => {
    this.isVisible = false;
    this.close.emit();
    this.arquivoSelecionado = undefined;
    this.permiteSalvarRegistro = false;
    this.tipoSelecionado = 0;
    this.permiteSalvar = false;
  };

  onFileSelected(event: any) {
    this.arquivoSelecionado = event.target.files[0];
    const tipoArquivo = this.arquivoSelecionado.type;

    if (this.tiposArquivoBloqueados.includes(tipoArquivo)) {
      Swal.fire({
        title: "Alerta!",
        text: "Tipo de arquivo não permitido.",
        icon: "error",
      }).then(() => {
        this.close.emit();
        this.arquivoSelecionado = null;
        event.target.value = null;
      });
    } else {
      this.permiteSalvar = true;
      this.permiteSalvarRegistro = false;
    }
  }

  uploadArquivo() {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    
    this.service
      .postFile(
        `Arquivo/DocumentoExternoPaciente/${this.atendimento.cidadao_uuid}`,
        this.arquivoSelecionado
      )
      .then(
        (result) => {
          if (result) {
            var regex = /^"|"$/g;
            this.nomeArquivoSalvo = result["_body"].replace(regex, "");
            this.permiteSalvarRegistro = true;
            this.permiteSalvar = false;
            this.arquivoSelecionado = null;
            this.salvar();            
          }
        },
        (error) => {
          Swal.fire("Error", error.error.messagem, "error");
        }
      );
  }
  salvar() {
    var request = {
      tipo_documento: this.tipoSelecionado,
      cidadao_id: this.atendimento.cidadao_id,
      atendimento_id: this.atendimento.id,
      nome_arquivo: this.nomeArquivoSalvo,
    };

    this.service.Post("DocumentoExterno", request).then(
      (result) => {
        if (result) {
          Swal.fire({
            title: "Sucesso!",
            text: "Arquivo salvo com sucesso.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            Swal.close();
            this.fecharModal();
          });
        }
      },

      (error) => {
        Swal.fire("Error", error.error.messagem, "error");
      }
    );
  }  
}
